var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "form",
        {
          staticClass: "m-form m-form--state",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-12",
                  class: { "has-danger": _vm.errors.has("name") }
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("name")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.language.name,
                        expression: "language.name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:2|max:20",
                        expression: "'required|min:2|max:20'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: { type: "name", name: "name" },
                    domProps: { value: _vm.language.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.language, "name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("name")) + " ")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-12",
                  class: { "has-danger": _vm.errors.has("code") }
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("code")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.language.locale,
                        expression: "language.locale"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:2|max:5",
                        expression: "'required|min:2|max:5'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: { type: "locale", name: "code" },
                    domProps: { value: _vm.language.locale },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.language, "locale", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("code"),
                          expression: "errors.has('code')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("code")) + " ")]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal", id: "btn-cancel" },
          on: { click: _vm.resetForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel"))) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.submitForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("submit"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8337d898", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8337d898","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/languages/New.vue
// module id = 490
// module chunks = 0 1 65 161